import { sse } from '#pplx/frontend/api-clients/core/client.js';
export const streamClient = {
    // @ts-expect-error - JsonMessage is a subtype of object. This is too complex for TS to type properly
    SSE: (...args) => sse(...args),
};
//# sourceMappingURL=index.js.map